import "./globals"
import "jquery-ujs"
import "bootstrap"

// Admin: drag & drop ordering of works and photos, nested author fields.
// jQuery UI's modules only load their dependencies under AMD; here they use the global
// jQuery, so the dependencies of sortable are imported first, in order.
import "jquery-ui/ui/version"
import "jquery-ui/ui/widget"
import "jquery-ui/ui/data"
import "jquery-ui/ui/scroll-parent"
import "jquery-ui/ui/widgets/mouse"
import "jquery-ui/ui/widgets/sortable"
import "@nathanvda/cocoon"

import "./functions"
import "./map"
import "./works"
